// extracted by mini-css-extract-plugin
export default {"container":"CustomTabs_container__rrv3h","tabsHeader":"CustomTabs_tabsHeader__ifvAo","tabs":"CustomTabs_tabs__vV79H"};